var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeenyiconsFileTickSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6001 2.4C1.6001 1.76348 1.85295 1.15303 2.30304 0.702944C2.75313 0.252856 3.36358 0 4.0001 0L17.1313 0L22.4001 5.2688V21.6C22.4001 22.2365 22.1472 22.847 21.6972 23.2971C21.2471 23.7471 20.6366 24 20.0001 24H4.0001C3.36358 24 2.75313 23.7471 2.30304 23.2971C1.85295 22.847 1.6001 22.2365 1.6001 21.6V2.4ZM11.2385 16.3712L17.4017 9.3264L16.1985 8.2736L11.1617 14.0304L8.5665 11.4336L7.4337 12.5664L11.2385 16.3712Z",
    fill: "#018DC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsFileTickSolid);
export default __webpack_public_path__ + "static/media/teenyicons_file-tick-solid.436c10f899be1c2921ab4294cead90f0.svg";
export { ForwardRef as ReactComponent };